/* Mini-cart popover: click pe iconița coș → popover mic sub icon; "Vezi coșul" → /cart */
(function () {
  if (window.__miniCartPopover) return;
  window.__miniCartPopover = true;

  let popover = null;

  function money(cents) {
    return (cents / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
  }

  function close() {
    if (popover) { popover.remove(); popover = null; }
    document.removeEventListener('click', onOutside, true);
  }

  function onOutside(e) {
    if (popover && !popover.contains(e.target) && !(e.target.closest && e.target.closest('header-actions') && e.target.closest('button'))) close();
  }

  function render(cart) {
    close();
    popover = document.createElement('div');
    popover.className = 'mini-cart-popover';

    if (!cart.items || cart.items.length === 0) {
      popover.innerHTML = '<p class="mcp-empty">Coșul tău este gol</p>';
    } else {
      const rows = cart.items.map(function (it) {
        const img = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '';
        return '<div class="mcp-item" data-key="' + it.key + '">' +
          '<div class="mcp-item-img">' + img + '</div>' +
          '<div class="mcp-item-info"><div class="mcp-item-title">' + it.product_title + '</div>' +
          '<div class="mcp-item-qty">x' + it.quantity + '</div></div>' +
          '<div class="mcp-item-price">' + money(it.final_line_price) + '</div>' +
          '<button class="mcp-remove" data-key="' + it.key + '" aria-label="Șterge">×</button>' +
          '</div>';
      }).join('');
      popover.innerHTML = rows +
        '<div class="mcp-total"><span>Preț total (' + cart.item_count + (cart.item_count === 1 ? ' produs' : ' produse') + ')</span>' +
        '<strong>' + money(cart.total_price) + '</strong></div>' +
        '<a class="mcp-view-cart" href="/cart">Vezi coșul</a>';
    }

    document.body.appendChild(popover);
    const icon = document.querySelector('header-actions button') && isCartButton(document.querySelector('header-actions button')) ? isCartButton(document.querySelector('header-actions button')) : null;
    const iconEl = icon || document.querySelector('header-actions button');
    if (iconEl) {
      const r = iconEl.getBoundingClientRect();
      popover.style.top = r.bottom + 10 + window.scrollY + 'px';
      let left = r.left + r.width / 2 - 170;
      left = Math.max(10, Math.min(left, window.innerWidth - 350));
      popover.style.left = left + 'px';
    }
    document.addEventListener('click', onOutside, true);

    popover.querySelectorAll('.mcp-remove').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart.item_count === 0) {
              // coș gol: reîncărcăm pagina ca să se actualizeze totul (badge, mesaje, secțiuni temă)
              window.location.reload();
              return;
            }
            render(cart);
          });
      });
    });
  }

  function isCartButton(t) {
    const clone = t.closest && t.closest('button[data-pagepilot-cart-drawer-clone]');
    if (clone && clone.offsetParent !== null) return clone;
    const btn = t.closest && t.closest('header-actions button');
    if (!btn) return null;
    return /^co[șs]/i.test((btn.innerText || '').trim()) ? btn : null;
  }

  document.addEventListener('click', function (e) {
    const icon = isCartButton(e.target);
    if (!icon) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (popover) { close(); return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
  }, true);

  // reposition on scroll/resize
  window.addEventListener('scroll', function () {
    if (!popover) return;
    const icon = document.querySelector('header-actions button');
    if (!icon) return;
    const r = icon.getBoundingClientRect();
    popover.style.top = r.bottom + 10 + window.scrollY + 'px';
  }, { passive: true });
})();
